import React from 'react'
import { Button } from 'lib/ui'
import { MagentoConfigurableProductOptions } from 'lib/types'
import { AddToWishlist } from 'components/AddToWishlist'
import { Wrapper } from './styled'
import { AddToCompare } from '../../../AddToCompare'

interface Props {
  handleClick: () => void
  configurableOptions?: MagentoConfigurableProductOptions[]
  sku: string
}

export const Actions = ({ handleClick, configurableOptions, sku }: Props) => {
  return (
    <div className='actions'>
      <Button
        onClick={handleClick}
      >
        {configurableOptions && configurableOptions?.length > 0 ? 'Choose Your Options' : 'View Product'}
      </Button>
      <Wrapper>
        <AddToCompare sku={sku} useIcon />
        <AddToWishlist sku={sku} hasText />
      </Wrapper>
    </div>
  )
}
